<template>
  <div class="el-main">
    <!-- <div class="card"
    v-show="currentCardId == 'occupation'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職種</h2>
        <p>後の入力項目で選択した職種に合わせた例文が使えます</p>
      </div>
      <div class="card-content">
        <div>
        <el-select v-model="formatData.occupation"
          placeholder="Select">
          <el-option v-for="item in occupationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        </div>
      </div>
    </div>
  </div> -->

    <div class="card" v-show="currentCardId == 'company'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>応募会社</h2>
          <p>送付状に記載する会社名と担当者情報を記載しましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item">
              <div class="item-name">応募する会社名</div>
              <div class="item-body">
                <el-input placeholder="株式会社Yagish" class="input-md" title="応募する会社名" ref="letter-company"
                  v-model="formatData.company_name"></el-input>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">応募会社の担当者　</div>
              <div class="item-body">
                <el-input placeholder="ご担当者" class="input-md" title="応募会社の担当者" ref="letter-staff"
                  v-model="formatData.staff_name"></el-input>
              </div>
              <div class="attention-limit character" v-if="staff_name_Error && false">
                <i class="el-icon-warning"></i> 「様」や「さま」の入力が見つかりました。敬称(様)は自動入力されますので、入力しないでください。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'intro'">

      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>頭語と時候のあいさつ</h2>
          <p>頭語と時候のあいさつを入力しましょう</p>
          <div class="add-item">
            <el-button @click="$modal.show('intro-dialog')" style="background-color:#004D40;border-color:#004D40;"
              type="success">例文から追加</el-button>
          </div>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item">
              <div class="item-name">タイトル（{{ letterTitleLength }}/{{ letterTitleMaxLength }}文字）</div>
              <div class="item-body letter-title-body">
                <el-input class="input-md letter-title-input" :placeholder="letterTitleDefault"
                  :maxlength="letterTitleMaxLength" title="送付状のタイトル"
                  v-model="formatData.letterTitle"></el-input>
                <span class="unit">の送付につきまして</span>
              </div>
            </div>
          </div>
          <modal name="intro-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('intro-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in filtered(exampleSentences.intro)"
                v-on:click="formatData.introSummary = item.sentences.replace(/<br>/ig, '\n'); checklog(); $modal.hide('intro-dialog')"
                :key="index">
                <div class="title">{{ item.name }}</div>
                <div class="body" v-html="item.sentences"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('intro-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.introSummary"
            :autosize="{ minRows: 5, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.introSummary">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くしてください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'entry-detail'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>応募経緯</h2>
          <p>応募経緯を入力しましょう</p>
          <div class="add-item">
            <el-button @click="$modal.show('entry-dialog')" style="background-color:#004D40;border-color:#004D40;"
              type="success">例文から追加</el-button>
          </div>
        </div>
        <div class="card-content">
          <modal name="entry-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('entry-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in filtered(exampleSentences.entry)"
                v-on:click="formatData.entrySummary = item.sentences.replace(/<br>/ig, '\n'); checklog(); $modal.hide('entry-dialog')"
                :key="index">
                <div class="title">{{ item.name }}</div>
                <div class="body" v-html="item.sentences"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('entry-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.entrySummary"
            :autosize="{ minRows: 5, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.entrySummary">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くしてください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'resume-list'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>同封書類</h2>
          <p>同封する書類の名前と通数を入力しましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item">
              <div class="item-name">同封書類（入力した書類だけが上から順に記載されます）</div>
              <div class="item-body">
                <div class="resume-item" v-for="(item, index) in formatData.resumeItems" :key="index">
                  <span class="resume-item-no">{{ index + 1 }}．</span>
                  <el-input class="input-md resume-item-name" placeholder="履歴書"
                    :title="(index + 1) + 'つめの同封書類名'" v-model="item.name"></el-input>
                  <el-input class="input-2-digit resume-item-count" type="tel" maxlength="2" placeholder="1"
                    :title="(index + 1) + 'つめの同封書類の通数'" :value="item.count"
                    @input="setResumeItemCount(index, $event)"></el-input>
                  <span class="unit">通</span>
                </div>
              </div>
            </div>
          </div>
          <div class="attention-limit character" v-if="previewErrors.resumeSummary">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。書類名を短くしてください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>送付状の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="選択してください"
                  :format="'yyyy年M月d日'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
          <div v-if="false">
            <el-collapse accordion v-model="activeName">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">オススメ</span>印刷から郵送まであなたの代わりに！ヤギの宅配便サービス
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <p>就職または転職を考えている企業先に、あなたの代わりにヤギッシュが「履歴書」「送付状」「封筒」を印刷して郵送いたします。（職務経歴書は自由選択）<br>

                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId);">
                        <h3>ヤギの宅配便<span>をつかう</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>


    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>ダウンロード</h2>
          <p>作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
        </div>
        <div class="card-content">
          <div class="button-download-pdf">
            <h3 class="next_bnr">選択中のフォントはコレ！</h3>

            <p v-if="formatData.selFontStyle" :style="formatData.selFontStyle" style="text-align: center;"><el-button
                v-ripple plain @click="$eventHub.$emit('show-preview');" type="success"
                style="border-color:#555;color:#000;text-align: center;" id="preview-button-format-edit"><i
                  class="el-icon-view"></i> {{ formatData.selectedFontName }}</el-button></p>
            <p v-else style="text-align: center;"><el-button v-ripple plain @click="$eventHub.$emit('show-preview');"
                type="success" style="border-color:#555;color:#000;text-align: center;"
                id="preview-button-format-edit"><i class="el-icon-view"></i> デフォルト</el-button></p>
            <p class="bnr_note" style="text-align: center;">※プレビューで確認、再選択できます。</p>

            <div class="bnr_container">
              <div class="bnr_itemWrapper">
                <div class="bnr_item" v-if="false">
                  <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便">
                  <div class="bnr_txt">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      <p>履歴書送付は任せろメェ〜</p>
                      <br>
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/static/renew_img/print.png" alt="コンビニプリント">
                  <div class="bnr_txt">
                    <el-button id="pdf-eprint-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      <p>面接に履歴書が必要？印刷だメェ〜</p>
                      <br>
                      <h3>コンビニプリント<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      <p>登録したメアドに送るメェ〜</p>
                      <br>
                      <h3>PDFをメールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
                </div>
              </div>
              <div class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                      <p>端末に保存するメェ〜</p>
                      <br>
                      <h3>PDFをダウンロードする</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note">
                    <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                      rel="nofollow">※できない場合はこちら</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-content">
          <el-collapse v-model="downloadActiveCollapses">

            <el-collapse-item title="ヤギにはがきを渡す" v-if="false" name="postcard">
              <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                    src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
            </el-collapse-item>

            <el-collapse-item title="スマホから履歴書を印刷するには" name="print">
              <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。
              </div>
              <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
              <ul class="collapse-list" v-if="$firebase.isAuthenticated">
                <li>
                  <a id="pdf-eprint-edit" type="success" style="cursor:pointer;" :disabled="!$deviceLib.isOnline"
                    @click="$eventHub.$emit('show-preview-4conv')">
                    セブンイレブン・ファミリーマート・ローソンなど - eプリント
                  </a>
                </li>
              </ul>
            </el-collapse-item>
            <el-collapse-item title="他の端末から続きを書くには" name="backup">
              <div>
                他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'output'" v-else>
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>ダウンロード</h2>
          <p>作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
        </div>
        <div class="card-content">
          <div class="text-center fluffy">
            <your-yagi :your-yagi-class="{}"
              :yagi-options="{ dialogEnabled: false, rubyEnabled: false, messageEnabled: true, fixedMessage: 'さいごまでがんばった！' }"></your-yagi>
          </div>
          <div class="button-download-pdf">
            <h3>フォント</h3>
            <p v-if="formatData.selFontStyle" :style="formatData.selFontStyle"><el-button v-ripple plain
                @click="$eventHub.$emit('show-preview');" type="success" style="border-color:#555;color:#000"
                id="preview-button-format-edit"><i class="el-icon-view"></i> {{ formatData.selectedFontName
                }}</el-button>
            </p>
            <p v-else><el-button v-ripple plain @click="$eventHub.$emit('show-preview');" type="success"
                id="preview-button-format-edit"><i class="el-icon-view"></i> デフォルト</el-button></p>
            <div v-if="!$firebase.isAuthenticated">
              <a :href="'/login?frompage=' + this.formatId"><img src="/static/renew_img/bnr/banner_not_login.png"
                  style="text-align:center;width:100%"></a>
            </div>
            <div v-if="$firebase.isAuthenticated && getMode != 'production' && true" class="attention-logged-in">
              <p>ヤギの宅配便</p>
              <el-button id="send-marunage" type="primary" plain class="button-block"
                style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                @click="$eventHub.$emit('send-special-post'); isSendYagiPostEnabled = false">
                <i class="el-icon-message"></i> ヤギの宅配便で履歴書を郵送する
              </el-button>
            </div>
            <div v-if="$firebase.isAuthenticated && true" class="attention-logged-in">
              <p>PDFをあなたのメール宛てに送ります。</p>
              <el-button id="pdf-mail-edit" type="primary" plain class="button-block"
                style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                <i class="el-icon-message"></i> PDFをメールで送る
              </el-button>
              <p>バックアップデータはマイページで確認できます</p>
              <el-button class="button-block" v-if="false" :disabled="!$deviceLib.isOnline"
                @click="$router.push({ name: 'backupIndex' })"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

            </div>
            <el-button id="pdf-download-edit" v-if="$firebase.isAuthenticated && !true" class="button-block animation"
              type="primary" style="background-color:#E95B10;border-color:#E95B10"
              :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
              @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false">
              <i class="el-icon-download"></i> ダウンロードする
            </el-button>
            <div v-if="$firebase.isAuthenticated" class="attention-logged-in">
              <el-button id="pdf-eprint-edit" type="success" class="button-block"
                style="background-color:#004D40;border-color:#004D40" @click="$eventHub.$emit('show-preview-4conv')">
                <i class="el-icon-printer"></i> コンビニで印刷する
              </el-button>
              <p>※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。</p>
            </div>
            <br />
            <div v-if="isMynabi" class="attention-logged-in">
              <el-button id="mynavi-back" type="primary" plain class="button-block" :disabled="!$deviceLib.isOnline"
                onclick="location.href='https://tenshoku.mynavi.jp/knowhow/rirekisho?af=yagish'">
                【履歴書の書き方を見る】
              </el-button>
              <p class="addition">採用担当者のチェックポイント・送り方なども解説！</p>
            </div>
            <br />
            <el-button id="pdf-download-edit" v-if="$firebase.isAuthenticated && true" class="button-block animation"
              type="primary" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
              style="background-color:#fce8ef;border-color:#f4a2be;color:#e3165c"
              @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false">
              <i class="el-icon-download"></i> ダウンロードする
            </el-button>
            <br>
            <div v-if="$firebase.isAuthenticated && !true" class="attention-logged-in">
              <p>PDFをあなたのメール宛てに送ります。</p>
              <el-button id="pdf-mail-edit" type="primary" plain class="button-block"
                style="color: #E95B10;background-color: #FFF3EC;border-color: #FF813F;"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                <i class="el-icon-message"></i> PDFをメールで送る
              </el-button>
              <p>入力したデータの引き継ぎにはバックアップをおすすめします</p>
              <el-button class="button-block" v-if="false" :disabled="!$deviceLib.isOnline"
                @click="$router.push({ name: 'backupIndex' })"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

            </div>
            <div v-if="!$firebase.isAuthenticated" class="attention-not-logged-in">
              <p>ログインすると、他の端末からも続きを書けるようにデータをバックアップできます。<br />また、「コンビニ印刷」のサービスをご利用いただけます。</p>
              <login-forms :is-plain-button="true" />
            </div>

            <div class="error" v-if="!$deviceLib.isOnline">現在オフラインのためダウンロードはご利用頂けません。ネットワークに繋げてからお試しください。
            </div>
          </div>
        </div>
        <div class="card-content">
          <el-collapse v-model="downloadActiveCollapses">
            <el-collapse-item title="ヤギにはがきを渡す" v-if="false" name="postcard">
              <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                    src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
            </el-collapse-item>
            <el-collapse-item title="他の端末から続きを書くには" name="backup">
              <div>
                他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.bnr_note {
  font-size: 0.8rem;
}


.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<script>
// import HistoryItem from './RirekishoParts/HistoryItem'
import HistoryItemSkill from './ShokurekishoParts/HistoryItemSkill'
import HistoryItemJob from './ShokurekishoParts/HistoryItemJob'
// import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
// import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
// 同封書類の入力欄の数（プレビュー・PDFも同じ数まで出力されます）
const RESUME_ITEM_ROWS = 5
const createResumeItems = function () {
  const items = []
  for (let i = 0; i < RESUME_ITEM_ROWS; i++) {
    items.push({ name: '', count: '' })
  }
  return items
}
const SkillHistoryData = function (columns) {
  this.skillname = columns.skillname || ''
  this.years = Number(columns.years) || ''
  this.description = columns.description || ''
  this.uuid = uuidv4()
}
// const SkillHistoryData2 = class sh {
//   constructor (columns) {
//     this.skillname = columns.skillname || ''
//     this.years = Number(columns.years) || ''
//     this.description = columns.description || ''
//     this.uuid = uuidv4()
//   }
//   run () {
//     return (this.uuid)
//   }
// }
const JobHistoryData = function (columns) {
  this.companyName = columns.companyName || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.isContinuing = columns.isContinuing || false
  this.capitalStock = columns.capitalStock || ''
  this.numberOfEmployees = columns.numberOfEmployees || ''
  this.businessArea = columns.businessArea || ''
  this.projects = columns.projects || []
  this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
  this.projectTitle = columns.projectTitle || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.contentsOfProject = columns.contentsOfProject || ''
  this.envAndScale = columns.envAndScale || ''
  this.position = columns.position || ''
  this.uuid = uuidv4()
}

export default {
  name: 'LetterEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItemJob,
    'history-item-skill': HistoryItemSkill,
    // 'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'letter',
      activeName: '1',
      formatData: {
        createDate: null,
        letterTitle: '',
        introSummary: '',
        entrySummary: '',
        resumeSummary: '',
        resumeItems: createResumeItems(),
        occupation: 'others',
        jobSummary: '',
        experienceAndKnowledge: '',
        skillsToUse: [],
        jobHistories: [],
        licenseHistories: [],
        prMessage: ''
      },
      staff_name_Error: false,
      activeHistoryItem: '',
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      eprintPdfEnabled: true,
      downloadActiveCollapses: ['postcard'],
      occupationOptions: [
        {
          value: 'engineer',
          label: 'エンジニア'
        },
        {
          value: 'sales',
          label: '営業'
        },
        {
          value: 'backoffice',
          label: '事務'
        },
        {
          value: 'others',
          label: 'その他'
        }
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    letterTitleDefault: function () {
      return this.$formLib.letterTitleDefault
    },
    letterTitleMaxLength: function () {
      return this.$formLib.letterTitleMaxLength
    },
    letterTitleLength: function () {
      return String(this.formatData.letterTitle || '').length
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  watch: {
    formatData: function () {
      console.log(this.formatData.staff_name)
      if (this.formatData.jobHistories.length === 0) {
        // this.addJobHistory()
        // this.addProjectHistory(0)
        // this.createProjectHistoryItem()
        // console.log('asdf')
      }
    },
    'formatData.staff_name': function (newValue, oldValue) {
      console.log(newValue)
      if (newValue.indexOf('さま') >= 0 || newValue.indexOf('様') >= 0) {
        this.staff_name_Error = true
      } else {
        this.staff_name_Error = false
      }
    }
  },
  methods: {
    filtered: function (obj) {
      var selectedOccupation = this.formatData.occupation
      return obj.filter(function (item) {
        return item.type === selectedOccupation
      })
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createJobHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new JobHistoryData(columns)
    },
    createProjectHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new ProjectHistoryData(columns)
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    checklog: function () {
      console.log(this.formatData)
    },
    setResumeItemCount: function (index, value) {
      const item = this.formatData.resumeItems[index]
      if (!item) return
      // 通数は半角数字のみ受け付ける
      this.$set(item, 'count', String(value).replace(/[^0-9]/g, '').slice(0, 2))
    },
    normalizeResumeItems: function () {
      const source = Array.isArray(this.formatData.resumeItems) ? this.formatData.resumeItems : []
      const items = createResumeItems()
      source.slice(0, RESUME_ITEM_ROWS).forEach(function (item, index) {
        if (!item) return
        items[index].name = String(item.name || '')
        items[index].count = String(item.count || '').replace(/[^0-9]/g, '').slice(0, 2)
      })
      const isEmpty = items.every(function (item) { return !item.name })
      if (isEmpty && this.formatData.resumeSummary) {
        this.$formLib.resumeItemsFromSummary(this.formatData.resumeSummary)
          .slice(0, RESUME_ITEM_ROWS)
          .forEach(function (item, index) {
            items[index].name = item.name
            items[index].count = item.count
          })
      }
      this.$set(this.formatData, 'resumeItems', items)
    },
    onLocalFormatDataLoaded: function (saveName) {
      if (saveName !== this.saveName) return
      this.normalizeFormatData()
    },
    normalizeFormatData: function () {
      // 旧データにはない項目なので読み込み後に補う
      if (typeof this.formatData.letterTitle !== 'string') {
        this.$set(this.formatData, 'letterTitle', '')
      }
      this.normalizeResumeItems()
    },
    addSkillHistory: function (index, columns) {
      const historyList = this.formatData.skillsToUse
      if (!columns) columns = {}
      const newHistoryItem = new SkillHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addJobHistory: function (index, columns) {
      const historyList = this.formatData.jobHistories
      if (!columns) columns = {}
      const newHistoryItem = new JobHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addProjectHistory: function (index, columns) {
      // const targetItem = this.formatData.jobHistories.find((item) => {
      //   return (item.uuid === this.activeHistoryItem)
      // })
      const targetItem = this.formatData.jobHistories[index]
      if (!columns) columns = {}
      const newHistoryItem = new ProjectHistoryData(columns)
      targetItem.projects.push(newHistoryItem)
    },
    moveSkillHistory: function (params) {
      this.moveHistory(this.formatData.skillsToUse, params)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    moveJobHistoryDetail: function (params, parentIndex) {
      this.moveHistory(this.formatData.jobHistories[parentIndex].projects, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteSkillHistory: function (index) {
      this.formatData.skillsToUse.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteHistoryDetail: function (index, index2) {
      console.log(index, index2)
      this.formatData.jobHistories[index].projects.splice(index2, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      console.error('dataChanged')
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    this.normalizeFormatData()
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('local-format-data-loaded', this.onLocalFormatDataLoaded)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('local-format-data-loaded', this.onLocalFormatDataLoaded)
  }
}
</script>
<style scoped lang="scss">
.letter-title-body {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .unit {
    white-space: nowrap;
  }
}

.letter-title-input {
  flex: 1 1 200px;
}

.resume-item {
  display: flex;
  align-items: center;

  & + .resume-item {
    margin-top: 0.5rem;
  }
}

.resume-item-no {
  flex: 0 0 auto;
  width: 1.75rem;
  font-size: 0.875rem;
}

.resume-item-name {
  flex: 1 1 auto;
}

.resume-item-count {
  flex: 0 0 auto;
  margin-left: 0.5rem;
}
</style>
